import { render } from "./P2PChat.vue?vue&type=template&id=2062c9c9&scoped=true"
import script from "./P2PChat.vue?vue&type=script&lang=js"
export * from "./P2PChat.vue?vue&type=script&lang=js"

import "./P2PChat.vue?vue&type=style&index=0&id=2062c9c9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2062c9c9"]])

export default __exports__